import { render, staticRenderFns } from "./AppLayoutHeader.vue?vue&type=template&id=8f57a1e0&scoped=true&"
import script from "./AppLayoutHeader.vue?vue&type=script&lang=js&"
export * from "./AppLayoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutHeader.vue?vue&type=style&index=0&id=8f57a1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f57a1e0",
  null
  
)

export default component.exports